
const SendIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
            <g clipPath="url(#clip0_98_2616)">
                <path d="M10.9019 16.2644C10.9303 16.3354 10.9799 16.396 11.0438 16.4381C11.1077 16.4801 11.183 16.5016 11.2595 16.4997C11.336 16.4977 11.41 16.4724 11.4717 16.4271C11.5334 16.3818 11.5798 16.3188 11.6046 16.2464L16.4796 1.99642C16.5036 1.92997 16.5082 1.85805 16.4928 1.78909C16.4774 1.72012 16.4427 1.65697 16.3928 1.607C16.3428 1.55704 16.2797 1.52234 16.2107 1.50696C16.1417 1.49159 16.0698 1.49617 16.0034 1.52017L1.75335 6.39517C1.68098 6.41999 1.61792 6.46636 1.57266 6.52805C1.52739 6.58974 1.50208 6.6638 1.50012 6.74029C1.49816 6.81678 1.51965 6.89204 1.5617 6.95597C1.60375 7.01989 1.66434 7.06943 1.73535 7.09792L7.68285 9.48292C7.87087 9.5582 8.04169 9.67077 8.18503 9.81384C8.32836 9.95692 8.44124 10.1275 8.51685 10.3154L10.9019 16.2644Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M16.3905 1.61035L8.18555 9.8146" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_98_2616">
                    <rect width="18" height="18" fill="white" />
                </clipPath>
            </defs>
        </svg>
    )
}

export default SendIcon